
/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { User } from "@src/app/model/user";
import { NavRoute } from "@src/app/shared/NavRoute";
import { Txn } from "@src/app/model/txn";
import { InvoicePageComponent } from "@src/app/modules/txn/invoice-page/invoice-page.component";

export const InvoicePageNavRoute = new NavRoute(Txn.TYPE.INVOICE.code, ()=>InvoicePageComponent, 'sell').setViews((u: User) => {
    return [
        {
            id: 'currentYear',
            name: 'Current Year',
            helpText: 'Service charge invoices for the current financial year; change the year filter to view a different year',
            filterFields: {
                refNr: null,
                txnCycleId: u.currentTeam.currentPeriod?.cycleId,
                txnPeriodId: 'All',
            },
        }, {
            id: 'outstanding',
            name: 'Outstanding',
            helpText: 'Invoices with an outstanding balance',
            filterFields: {
                outstanding: '>=0.01',
            },
            sort: 'createdAt'
        }
    ]
});
